import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { Routes } from "@/router";
import { useStore } from "@/store";
import { ActionTypes } from "@/store/modules/content/action-types";
import { computed, onMounted } from "vue";
import MatchdButton from "./MatchdButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChallengeTypeMentoringButton',
  setup(__props) {

const store = useStore();

const challengeTypeMentoring = computed(() =>
  store.getters["challengeTypes"]?.find((ct) => ct.name === "Mentoring"),
);

onMounted(async () => {
  await store.dispatch(ActionTypes.CHALLENGE_TYPES);
});

return (_ctx: any,_cache: any) => {
  return (challengeTypeMentoring.value?.id)
    ? (_openBlock(), _createBlock(MatchdButton, {
        key: 0,
        class: "block w-full mt-8 text-center",
        to: {
      name: _unref(Routes).CHALLENGE_SEARCH,
      query: { challengeTypeId: challengeTypeMentoring.value.id },
    },
        tag: "router-link"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" Mentoring suchen ", -1)
        ]))]),
        _: 1
      }, 8, ["to"]))
    : _createCommentVNode("", true)
}
}

})